import classNames from "classnames";
import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import styles from "./AnimalButtons.module.css";
import { useSignupStore } from "components/Signup/store/hooks";
import { trackSignupEvent } from "components/Signup/analytics";
import { StepName } from "components/Signup/steps/types";

export const AnimalButtons = ({
  showDeleteButton = true,
  showModifyButton = true,
  onEdit,
  onRemove,
}: {
  showDeleteButton?: boolean;
  showModifyButton?: boolean;
  onEdit: VoidFunction;
  onRemove: VoidFunction;
}) => {
  const { t } = useWebTranslation();
  const { getState } = useSignupStore();

  return (
    <div className={styles.buttonsContainer}>
      {showDeleteButton ? (
        <button
          className={classNames(styles.button, styles.removeButton)}
          onClick={() => {
            trackSignupEvent("REMOVE_ANIMAL" as StepName, 0, getState());
            onRemove();
          }}
        >
          <Typography variant="body2" color="grey500">
            <strong>{t("global.remove")}</strong>
          </Typography>
        </button>
      ) : null}
      {showModifyButton ? (
        <button
          className={classNames(styles.button, styles.removeButton)}
          onClick={onEdit}
        >
          <Typography variant="body2" color="blue300">
            <strong>{t("global.edit")}</strong>
          </Typography>
        </button>
      ) : null}
    </div>
  );
};
